import TitleDashboard from '@components/general/Titles/TitleDashboard'
import React from 'react'
import { Accordion, Col, Container, Image, Row } from 'react-bootstrap'

const InfoKueski = () => {
  return (
    <Container>
        <Row className="mt-5">
            <Col className="rounded p-3">
                <div className="text-center">
                    <Image src={require("@assets/images/Kueski/logoKueski.png")} fluid width="200" />
                </div>

                <h4 className="my-4">¿Cómo funciona?</h4>

                <div className="mb-5 text-start">
                    <p>1. Al seleccionar la opción "Pagar con Kueski" como método de pago, seras redirigido al sitio oficial de Kueski pay para comenzar.</p>

                    <p>2. Deberás iniciar sesión con tu cuenta Kueski o en su caso crear una cuenta y registrarte.</p>

                    <p>3. Una vez inicies sesión y realices tu compra serás redirigido de vuelta a nuestro sitio para finalizar la compra.</p>
                </div>

                <h4 className="my-4">Preguntas frecuentes</h4>

                
                <div className='text-start'>
                    <Accordion className="mt-3" defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>¿Global Click procesa y aprueba las solicitudes de financiamiento?</Accordion.Header>
                            <Accordion.Body>
                           No, Global Click no revisa ni aprueba las solicitudes de financiamiento. Kueski es responsable del proceso, así como también del cobro de los pagos quincenales.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>¿Por qué tengo que crear una cuenta en kueski para solicitar planes de financiamiento?</Accordion.Header>
                            <Accordion.Body>
                            La creación de una cuenta en Kueski es necesaria para hacr un análisis de tu capacidad crediticia, esto permite confirmar inmediatamente el monto total preaprobado para compras con Kueski Pay en Global Click u otros comercios afiliados.

                            Este proceso único te permitirá tener una experiencia rápida y personalizada durante tus futuras compras.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Header>¿Donde puedo pagar el préstamo?</Accordion.Header>
                            <Accordion.Body>
                                 Visita <a href='https://kueskipay.com' target="_blank" rel="noreferrer" >kueskipay.com</a> para obtener más infoirmación sobre como pagar.
                            </Accordion.Body>
                        </Accordion.Item>

                         <Accordion.Item eventKey="3">
                            <Accordion.Header>¿Puedo solicitar un reembolso total o parcial?</Accordion.Header>
                            <Accordion.Body>
                                 Si, puedes solicitar la cancelación mediante nuestro chat en linea o llamando al <b>477 390 8301 ext. 101</b>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>

                   <div className="my-5">
                     <p>Para cualquier problema relacionado a tu crédito puedes consultar:</p>
                    <ul>
                        <li>WhatsApp mediante el siguiente <a href='https://api.whatsapp.com/send?phone=5213324704527' target='_blank' rel={"noreferrer"}>link</a></li>
                        <li>Telefono: <b>800 224 2264</b></li>
                        <li>El asistente virtual de Kueski Pay en <a href='https://kueskipay.com' target="_blank" rel="noreferrer">kueskipay.com</a></li>
                    </ul>
                   </div>

                </div>
            </Col>
        </Row>
    </Container>
  )
}

export default InfoKueski